import { gql } from 'apollo-boost'

import useMutation, { mutationTypes } from '@utils/graphqlUtils'

const MUTATION = gql`
  mutation(
    $id: String!
  ) {
    deleteOneIrrigationType(
      where: {
        id: $id
      }
    ) {
      id
    }
  }
`

export default () => (
  useMutation(MUTATION, `Tipo de rega eliminado`, mutationTypes.DELETE)
)

